import React, { useState } from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Calendar, ArrowRight } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';

const DateRangePicker = ({ startDate, endDate, onStartChange, onEndChange, label = "Timeline" }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const formatDateDisplay = (start, end) => {
    if (!start && !end) return 'Select dates';
    if (start && end) {
      return `${new Date(start).toLocaleDateString('fr-FR')} → ${new Date(end).toLocaleDateString('fr-FR')}`;
    }
    if (start) return `From ${new Date(start).toLocaleDateString('fr-FR')}`;
    if (end) return `Until ${new Date(end).toLocaleDateString('fr-FR')}`;
    return 'Select dates';
  };

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium flex items-center gap-2">
        <Calendar className="h-4 w-4" />
        {label}
      </Label>
      
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="w-full justify-start text-left font-normal"
          >
            <Calendar className="mr-2 h-4 w-4" />
            <span className="flex-1">{formatDateDisplay(startDate, endDate)}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-4" align="start">
          <div className="space-y-4">
            <div className="space-y-2">
              <Label className="text-xs font-medium text-gray-600">Start Date</Label>
              <Input
                type="date"
                value={startDate || ''}
                onChange={(e) => onStartChange(e.target.value)}
                className="w-full"
              />
            </div>
            
            <div className="flex items-center justify-center">
              <ArrowRight className="h-4 w-4 text-gray-400" />
            </div>
            
            <div className="space-y-2">
              <Label className="text-xs font-medium text-gray-600">End Date</Label>
              <Input
                type="date"
                value={endDate || ''}
                onChange={(e) => onEndChange(e.target.value)}
                min={startDate || undefined}
                className="w-full"
              />
            </div>
            
            <div className="flex justify-end pt-2 border-t">
              <Button 
                size="sm" 
                onClick={() => setIsOpen(false)}
                className="bg-[#1C3E53] hover:bg-[#2A5470]"
              >
                Done
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
      
      {/* Quick display of selected range */}
      {(startDate || endDate) && (
        <div className="text-xs text-gray-500 flex items-center gap-1">
          {startDate && <span>From {new Date(startDate).toLocaleDateString('fr-FR')}</span>}
          {startDate && endDate && <ArrowRight className="h-3 w-3" />}
          {endDate && <span>to {new Date(endDate).toLocaleDateString('fr-FR')}</span>}
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
